<nav class="sidebar w-72 h-full bg-white shadow-xl">
  <div class="h-full overflow-y-auto justify-between flex flex-col sidebar-scroll">
    <div>
      <div class="flex justify-center items-center h-20 m-5">
        <img [src]="branding.LOGO" [alt]="branding.APP_NAME" class="h-12 mb-2" />
      </div>
      <hr class="border-gray-200" />
      <div class="px-3 py-5">
        <ul>
          <ng-container *ngFor="let link of links">
            <div *ngIf="link.permissions">
              <li class="mb-1" *ngxPermissionsOnly="['Permissions.Roles.List']"></li>
            </div>
            <li class="mb-1"> 
              <ng-container *ngIf="link.hasChildren">
                <div
                  class="flex items-center p-2 rounded-lg cursor-pointer"
                  (click)="toggleExpand(link.name)"
                >
                  <i class="{{ link.icon }} mr-3 text-primary-gray sidebar-icon"></i>
                  <span class="text-primary-gray text-lg">{{ link.name }}</span>
                  <i
                    class="fa-solid fa-angle-up ml-auto text-primary-gray"
                    [ngClass]="{ 'rotate-180': !isExpanded(link.name) }"
                  ></i>
                </div>

                <div *ngIf="isExpanded(link.name)" class="pl-5 flex flex-col gap-1">
                  <ng-container *ngFor="let child of link.children">
                    <ng-container *ngIf="child.permissions; else noChildPermissions">
                      <a
                        class="sidebar-submenu-item flex items-center p-2 rounded-lg text-primary-gray"
                        [routerLink]="child.path"
                        routerLinkActive="active"
                        *ngxPermissionsOnly="child.permissions"
                      >
                        <i *ngIf="child.isFontAwesome" class="{{ child.icon }} mr-2"></i>
                        <span>{{ child.name }}</span>
                      </a>
                    </ng-container>
                    <ng-template #noChildPermissions>
                      <a
                        class="sidebar-submenu-item flex items-center p-2 rounded-lg text-primary-gray"
                        [routerLink]="child.path"
                        routerLinkActive="active"
                      >
                        <i *ngIf="child.isFontAwesome" class="{{ child.icon }} mr-2"></i>
                        <span>{{ child.name }}</span>
                      </a>
                    </ng-template>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngIf="!link.hasChildren">
                <div
                  class="flex items-center p-2 rounded-lg"
                  routerLinkActive="bg-background"
                  [routerLink]="link.path"
                >
                  <i
                    class="{{ link.icon }} mr-3 text-primary-gray sidebar-icon"
                    routerLinkActive="text-secondary"
                  ></i>
                  <a
                    class="text-primary-gray text-lg"
                    routerLinkActive="text-secondary"
                    >{{ link.name }}</a
                  >
                </div>
              </ng-container>
            </li>
          </ng-container>
        </ul>
        <hr class="border-gray-200" />
        <div class="mt-5">
          <button
            class="flex items-center w-full mb-4 p-2 rounded-lg"
            routerLink="/perfil"
            routerLinkActive="bg-background"
          >
            <i
              class="fa-solid fa-user mr-3 text-primary-gray sidebar-icon"
              routerLinkActive="text-secondary"
            ></i>
            <a
              class="text-primary-gray text-lg"
              routerLinkActive="text-secondary"
              >Minha Conta</a
            >
          </button>
          <button
            class="flex items-center w-full px-2 text-red-600"
            (click)="logout()"
          >
            <i class="fa-solid fa-right-from-bracket mr-3 sidebar-icon"></i>
            <a class="text-lg">Sair</a>
          </button>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="flex items-center px-5 w-full mb-5 mt-6 py-2 hover:bg-gray-50 transition-colors text-left"
      (click)="openNotificationCenter()"
    >
      <div class="relative flex-shrink-0">
        <img
          [src]="this.user?.avatarUrl"
          alt="Profile Photo"
          class="w-10 h-10 rounded-full object-cover"
          [class.ring-2]="unreadCount > 0"
          [class.ring-red-500]="unreadCount > 0"
          onerror="this.src='assets/img/profile_placeholder.png'"
        />

        <span
          *ngIf="unreadCount > 0"
          class="absolute -top-2 -right-2 min-w-5 h-5 px-1 rounded-full bg-red-600 text-white text-[10px] font-semibold flex items-center justify-center"
        >
          {{ unreadBadgeLabel }}
        </span>
      </div>

      <div class="ml-3 min-w-0 flex-1">
        <p class="text-primary-gray text-base font-medium truncate" [title]="user?.name">{{ user?.name }}</p>
      </div>

      <i class="fa-solid fa-chevron-right text-gray-400 text-xs"></i>
    </button>
  </div>
</nav>
